import { Component, OnInit, Input, ElementRef, ChangeDetectorRef, ViewEncapsulation, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { VgAPI, VgFullscreenAPI, VgControlsHidden, VgStates } from 'videogular2/core';
import { Observable } from 'rxjs';
import { Subscription } from 'rxjs/Subscription';

@Component({
    selector: 'vg-timed-popups',
    encapsulation: ViewEncapsulation.None,
    template: `<div class="vg-timed-popups" [ngClass]="" *ngIf="meta">
                    <ng-container *ngFor="let item of popups">
                        <div class="popup {{item.xposition | lowercase}} {{item.yposition | lowercase}}" *ngIf="item.active && !item.closed">
                            <a [vdgmRouterLink]="item.url" [url]="item.url" [target]="item.target" >
                                <img [src]="item.img" *ngIf="item.img" />
                                <h5 class="title" *ngIf="item.title">{{item.title}}</h5>
                                <p class="copy" *ngIf="item.summary">{{item.summary}}</p>                            
                            </a>
                            <span class="close" (click)="closePopup($event, item)"></span>
                        </div>
                    </ng-container>   
               </div>`,
    styles: [`        
        vg-timed-popups {
            z-index: 210;          
        }       
        vg-timed-popups.is-playing {          
        }
        vg-timed-popups .popup {            
            position: absolute !important; 
            opacity:0.5;
        }
        vg-timed-popups .popup:hover{
            opacity:1;
        }
        vg-timed-popups .close {
            position:absolute;
            display:block;            
        }
        vg-timed-popups .close::before {
            display:block;
            content: "x"
        }
    ` ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class VgTimedPopups implements OnInit, OnDestroy {
    @Input() vgFor: string;
    @Input() meta: any;

    private target: any;
    private subscriptions: Array<any> = [];
    //default timeout in ms. (used if popup item doesn't provide duration)
    private popupTimeout: number = 15000;
    get popups(): Array<any> { return Array.from(this.meta.popups || []); }

    constructor(public API: VgAPI, public fsAPI: VgFullscreenAPI, private controlsHidden: VgControlsHidden, private cd: ChangeDetectorRef) {
    }

    ngOnInit() {
        if (this.API.isPlayerReady) {
            this.onPlayerReady();
        }
        else {
            this.subscriptions.push(this.API.playerReadyEvent.subscribe(() => this.onPlayerReady()));
        }
    }

    onPlayerReady() {
        if (this.meta && this.popups.length > 0) {
            this.target = this.vgFor ? this.API.getMediaById(this.vgFor) : this.API.getDefaultMedia();
            this.subscriptions.push(this.fsAPI.onChangeFullscreen.subscribe(this.onChangeFullscreen.bind(this)));
            this.subscriptions.push(this.target.subscriptions.timeUpdate.subscribe(this.onTimeUpdate.bind(this)));
            this.cd.detectChanges();
        }
    }

    onChangeFullscreen(fsState) {
    }

    onTimeUpdate() {
        let currentTime = Math.floor(this.target.time.current);
        this.popups.forEach(i => { i["active"] = i.start && currentTime >= i.start && currentTime < i.start + (i.duration || this.popupTimeout); });
        this.cd.markForCheck();
    }

    closePopup(e, item) {
        item["closed"] = true;
    }

    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach(s => s.unsubscribe());
        }
    }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/video-player/controls/vg-timed-popups.component.ts